<template>
  <div id="workbench">
    <div class="ipub-h1 mar-b-20 relative">
      Reviews
    </div>
    <ipub-row :gutter="[12, 16]">
      <!-- <ipub-col :span="3">
        <ipub-select v-model="params.journalId"
                     placeholder="Select Journal"
                     @change="changeJournal"
                     :options="journalList" />
      </ipub-col> -->
      <ipub-col :span="12">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Enter Manuscript Title | Manuscript ID"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>
    <div class="ipub-p1 mar-b-20">
      <a v-for="(val, key) in  titleStatus"
         :key="key"
         @click="changeStatus(key)"
         style="margin-right:40px"
         :class="['ipub-list-tab--status', params.status === key ?'active':'']">{{val}} ({{countStatus[key]||0}})</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :empty="{icon:'icona-reviewreport'}"
                  :emptyText="emptyText[params.status]"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:img="{record}">
          <div>
            <img :src="`${domain}/${record.manuscript.journal.cover}`"
                 style="width:41px;height:58px"
                 alt="">
          </div>
        </template>
        <template v-slot:manuscriptNo="{record}">
          <div class="table-manuscriptNo-slot">
            <span class="ipub-p2">{{record.manuscript && record.manuscript.code}}</span>
            <ipub-label class="mar-l-10"
                        size="small"
                        type="warning"
                        cover>V{{record.sign}}</ipub-label>
          </div>
        </template>
        <template v-slot:title="{record}">
          <div class="table-manuscriptNo-slot">
            {{record.manuscript && record.manuscript.details && record.manuscript.details.title}}
          </div>
        </template>
        <template v-slot:special="{record}">
          <div class="omiss ipub-p2">
            {{record.manuscript && record.manuscript.details && record.manuscript.details.special && record.manuscript.details.special.titleText}}
          </div>
        </template>
        <template v-slot:status="{record}">
          <div>
            <p class="ipub-p2 fw-bd">{{academicStatus[record.status]}}</p>
            <span>{{$moment(record.statusTime).format('DD / MM / YYYY')}}</span>
          </div>
        </template>

        <template v-slot:actions="{ record }">
          <!-- 查看决策 Pending Pre Check -->
          <ipub-tooltip v-show="['PRE_CHECK_DONE','FIRST_DECISION_DONE','FINAL_DECISION_DONE',''].includes(record.status)"
                        placement="bottomLeft">
            <div slot="title">
              Review Decision
            </div>
            <ipub-icon @click="detail(record)"
                       type="iconViewDetails" />
          </ipub-tooltip>
          <div v-show="['TERMINATED_BY_EDITOR'].includes(record.status)">--</div>

          <!-- 提交决策 Pre Check Done -->
          <ipub-tooltip v-show="['PENDING_PRE_CHECK','PENDING_FIRST_DECISION','PENDING_FINAL_DECISION'].includes(record.status)"
                        placement="bottomLeft">
            <div slot="title">
              Submit Decision
            </div>
            <ipub-icon type="icona-SubmitDecision"
                       @click="commit(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>

    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="REVIEWER_APPLY_FOR_DELAYING_SUBMISSION"
               @cancel="cancel" />
  </div>

</template>


<script>
import main from './main'
export default main

</script>
<style lang="scss" scoped>
@import './main.scss';
</style>

